export default __webpack_public_path__ + "static/media/small.b2f6df9c.jpg";